import yup from 'src/libs/yup';

export const PartnerServiceStoreSchema = yup.object().shape({
  service_id: yup.string().required().label('Serviço'),
  teach_form_id: yup.string().nullable().label('Forma de Ensino'),
  discount: yup.string().required().label('Desconto'),
  file: yup.mixed().isFile().label('Arquivo'),
  message: yup.string().label('Mensagem'),
  custom_voucher_enabled: yup.bool(),
  custom_voucher_content: yup.string().label('Conteúdo do Voucher'),
  custom_voucher_qrcode: yup.string().label('Conteúdo do QRcode'),
  default_voucher_attached: yup.bool(),
  campaign_active: yup.bool(),
  campaign_start_at: yup.date().nullable().label('Início'),
  campaign_end_at: yup.date().nullable().label('Fim'),
  campaign_description: yup.string().label('Descrição'),
  campaign_image: yup.mixed().isFile().label('Imagem'),
  auto_fill: yup.boolean().default(false).label('Preenchimento Automático'),
});

export const PartnerServiceUpdateSchema = yup.object().shape({
  service_id: yup.string().required().label('Serviço'),
  teach_form_id: yup.string().nullable().label('Forma de Ensino'),
  discount: yup.string().required().label('Desconto'),
  file: yup.mixed().isFile().label('Arquivo'),
  message: yup.string().label('Mensagem'),
  custom_voucher_enabled: yup.bool(),
  custom_voucher_content: yup.string().nullable().label('Conteúdo do Voucher'),
  custom_voucher_qrcode: yup.string().nullable().label('Conteúdo do QRcode'),
  default_voucher_attached: yup.bool(),
  campaign_active: yup.bool(),
  campaign_start_at: yup.date().nullable().label('Início'),
  campaign_end_at: yup.date().nullable().label('Fim'),
  campaign_description: yup.string().label('Descrição'),
  campaign_image: yup.mixed().isFile().label('Imagem'),
  auto_fill: yup.boolean().default(false).label('Preenchimento Automático'),
});
